import { Col } from 'react-bootstrap';
import MainPanel from '../widgets/mainPanel';
import SidePanel from '../widgets/sidepanel';
import { useMobileQuery } from '../hooks/mediahooks';
import TopPanel from '../widgets/toppanel';

// function Home() 
const Home = () => {

	const isMobile = useMobileQuery();
	console.log(isMobile);
	return (
		isMobile ?
			<>
				<TopPanel />
				<MainPanel />
			</>
			:
			<>
				<Col md={{ span: 4 }}>
					<SidePanel />
				</Col>
				<Col md={{ span: 8 }}>
					<MainPanel />
				</Col>
			</>
	);
}

export default Home;